// extracted by mini-css-extract-plugin
export var docModalButton = "DocumentsModal-module--doc-modal-button--B8KLd";
export var docModalContainer = "DocumentsModal-module--doc-modal-container--KdtmC";
export var docModalRegister = "DocumentsModal-module--doc-modal-register--+2loJ";
export var primary = "#06004d";
export var secondary = "#4dafd7";